<template>
    <div id="main">
        <loading :isLoading="isLoading" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">{{ $t('vincular') }} {{ $t('lps') }}</h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="$emit('fecharModal', true)">
                    {{ $t('cancelar') }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="lpsSelected.length === 0"
                >
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>

        <div class="form-columns-fit">
            <div class="columns is-multiline">
                <div class="column is-8">
                    <div class="search-and-filter">
                        <div class="search-bar">
                            <search-bar :onSearch="debouncedOnSearch" tooltipLabel="msg-campo-busca-lps" />
                        </div>
                    </div>
                </div>
                <div class="column is-4">
                    <vss-select
                        title="redes"
                        :options="redeSelect"
                        :value="redeSelected"
                        :height="40"
                        @input="updateRede"
                        @search="carregarRedes"
                        :loading="redeLoading"
                        :closeOnSelect="false"
                        no-clearfix
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                        </template>
                    </vss-select>
                </div>
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="lpsList"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="lpsSelected"
                :custom-is-checked="(selecionados, linha) => selecionados.idlps === linha.idlps"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.label)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        idcontrato: 0,
    },
    data() {
        return {
            lpsList: [],
            lpsSelected: [],
            isLoading: false,
            isEmpty: false,
            redeSelect: [],
            redeSelected: [],
            redeLoading: false,
            fields: [
                { key: 'codigo', label: 'codigo', width: null, sortable: true },
                { key: 'nome', label: 'lps', width: null, sortable: true },
                { key: 'rsocial', label: 'rsocial', width: null, sortable: true },
                { key: 'endereco', label: 'endereco', width: null, sortable: true },
                { key: 'rede', label: 'rede', width: null, sortable: true },
            ],
            debouncedOnSearch: null,
            searchQuery: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [8, 16, 32],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
                column: 'nome',
                order: 'asc',
            },
            filtros: {
                idcontrato: this.idcontrato,
                idRedeList: [],
            },
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.$axios
                .post(`/promotor/contrato/contratolps/naoassociados`, this.filtros, {
                    params: {
                        page: currentPage - 1,
                        limit: this.pagination.perPage,
                        column: this.pagination.column,
                        order: this.pagination.order,
                        param: this.searchQuery
                    }
                })
                .then(this.mapItems)
                .then((value) => {
                    this.lpsList = value;
                    this.isEmpty = this.lpsList.length === 0;
                })
                .catch((_) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.data.totalElements;
            return body.data.content.map((m) => {
                return {
                    idcontrato: this.idcontrato,
                    idlps: m.idlps,
                    idrede: m.prorede.idrede,
                    rede: m.prorede.descricao ? m.prorede.descricao : '---',
                    codigo: m.idlpserp,
                    nome: m.nome,
                    rsocial: m.rsocial,
                    endereco: m.endereco,
                };
            });
        },
        carregarRedes(query = '') {
            this.redeLoading = true;

            this.$axios
                .get(`/pro/rede/getcombo.json`, {
                    params: {
                        param: query,
                    }
                })
                .then(this.mapRedes)
                .then((value) => {
                    this.redeSelect = value;
                })
                .catch(error => {
                    console.error('[REDES] Erro ao trazer dados das redes.', error);
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally((_) => {
                    this.redeLoading = false;
                })
        },
        mapRedes(body) {
            return body.data.content.map((r) => {
                return {
                    idprorede: r.idprorede,
                    idproredeerp: r.idproredeerp,
                    label: r.descricao
                };
            });
        },
        updateRede(rede) {
            this.redeSelected = rede;

            this.filtros.idRedeList =
                this.redeSelected.length == 0 ? [] : this.redeSelected.map((r) => r.idprorede);
            
            this.carregarDados();
        },
        sortTable(field, order) {
            this.pagination.column = field;
            this.pagination.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.searchQuery = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.lpsSelected.length > 0) {
                this.isLoading = true;

                this.$axios
                    .post(`/promotor/contratolps/bulk`, this.lpsSelected)
                    .then((body) => {
                        if (body.data.content === null) {
                            this.$root.showMessage('error', `${body.message}`, true);
                        } else {
                            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                            this.$emit('fecharModal', true);
                        }
                    })
                    .catch((e) => {
                        this.$root.showMessage('alert', 'msg-erro-ao-adicionar-associacao', true);
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.$root.showMessage('error', 'msg-selecione', true);
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
